import { cn } from "@/utils/cn";
import { fieldInputClass, fieldInputErrorClass } from "./fieldStyles";

type Props = {
  id: string;
  label: string;
  value: unknown;
  onChange: (v: string) => void;
  error?: string;
  rows?: number;
};

export function FieldTextarea({ id, label, value, onChange, error, rows = 3 }: Props) {
  return (
    <div className="mb-6">
      <label htmlFor={id} className="choice-textarea-label">
        {label}
      </label>
      <textarea
        id={id}
        rows={rows}
        className={cn(fieldInputClass, "min-h-[4.5rem]", error && fieldInputErrorClass)}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        value={typeof value === "string" ? value : value == null ? "" : String(value)}
        onChange={(e) => onChange(e.target.value)}
      />
      {error && <p id={`${id}-error`} className="choice-group__error" role="alert">{error}</p>}
    </div>
  );
}
